// extracted by mini-css-extract-plugin
export default {"description":"style_description__Wnt6c","fade-in":"style_fade-in__DRYRJ","top":"style_top__FnIwJ","image":"style_image__omEWz"};